module.exports = __webpack_public_path__ + "credito-5-d-jK5.png";